import { request, uploadRequest } from '../utils/request';

export function login(payload) {
  return request('/api/auth/login', { method: 'POST', body: JSON.stringify(payload) });
}

export function register(payload) {
  return request('/api/auth/register', { method: 'POST', body: JSON.stringify(payload) });
}

export function refresh(payload) {
  return request('/api/auth/refresh', { method: 'POST', body: JSON.stringify(payload) });
}

export function logout() {
  return request('/api/auth/logout', { method: 'POST' });
}

export function changePassword(payload) {
  return request('/api/auth/password', { method: 'PATCH', body: JSON.stringify(payload) });
}

export function profile() {
  return request('/api/auth/profile');
}

export function updateProfile(payload) {
  return request('/api/auth/profile', { method: 'PATCH', body: JSON.stringify(payload) });
}

export function uploadAvatar(file) {
  const formData = new FormData();
  formData.append('file', file);
  return uploadRequest('/api/auth/profile/avatar', formData);
}

export function removeAvatar() {
  return request('/api/auth/profile/avatar', { method: 'DELETE' });
}

export function sendVerificationCode(payload) {
  return request('/api/auth/verification/send', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function confirmVerificationCode(payload) {
  return request('/api/auth/verification/confirm', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
